import { render, staticRenderFns } from "./SchemeTextComeDown.vue?vue&type=template&id=0e75ab46&scoped=true&"
import script from "./SchemeTextComeDown.vue?vue&type=script&lang=js&"
export * from "./SchemeTextComeDown.vue?vue&type=script&lang=js&"
import style0 from "./SchemeTextComeDown.vue?vue&type=style&index=0&id=0e75ab46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e75ab46",
  null
  
)

export default component.exports